import { useEffect, useState } from 'react'
import { useAppDispatch } from '../../../redux/store'
import PracticeTraining from './Training'
import { addError } from '../../../redux/alerts';
import { CustomerTraining, CustomerTrainingMetadata, UserTrainingMetadata } from '../../../types'
import constants from '../../../constants'
import useCustomerNumber from '../../../hooks/useCustomerNumber'
import { getCustomerTrainingsWithMetadata } from './services'

const PracticeTrainingWrapper = () => {
  const customerNumber = useCustomerNumber()
  const dispatch = useAppDispatch()
  const [allCustomerTrainings, setAllCustomerTrainings] = useState<CustomerTraining[] | null>(null)
  const [customerTrainingMetadata, setCustomerTrainingMetadata] = useState<Partial<CustomerTrainingMetadata> | null>(null)
  const [userTrainingMetadata, setUserTrainingMetadata] = useState<UserTrainingMetadata[] | null>(null)

  const getCustomerTrainings = async () => {
    try {
      const data = await getCustomerTrainingsWithMetadata(customerNumber)
      setAllCustomerTrainings(data.customer_training)
      setCustomerTrainingMetadata(data.customer_training_metadata)
      setUserTrainingMetadata(data.user_training_metadata)
    } catch (error) {
      console.error(error)
      dispatch(addError(error instanceof Error ? error.message : 'There was an issue retrieving the customer trainings'))
    }
  }

  useEffect(() => {
    if (customerNumber) {
      getCustomerTrainings()
    }
  }, [customerNumber])

  if (allCustomerTrainings && customerTrainingMetadata && userTrainingMetadata) {
    return allCustomerTrainings.length
      ? (
          <PracticeTraining 
            allCustomerTrainings={allCustomerTrainings}
            customerTrainingMetadata={customerTrainingMetadata}
            userTrainingMetadata={userTrainingMetadata}
            getCustomerTrainings={getCustomerTrainings}
          />
        )
      : (<iframe className="iframe-sales-page" data-testid="sales-iframe" src={constants.OSHA_HIPAA_TRAINING_SALES_PAGE_IFRAME_URL} />)
  }
}

export default PracticeTrainingWrapper
